<template lang="pug">
.profile-setting-page.flex.column.gap-30
  .content-container.flex.column.align-center
    //- 連結逾期（後端 410 form_expired）時不顯示表單，請個案聯絡個管師重新發送
    .expired.flex.column.align-center.gap-10(v-if="expired")
      .expired-title 此連結已過期，請聯絡個管師重新發送
      .expired-sub This link has expired. Please contact customer service to resend it.
    .form.flex.column.gap-10(v-else)
      .row.flex.gap-10
        .flex.column.flex-1.gap-10
          .col-title 姓氏 ( Last Name )
          el-input(disabled, v-model="profile.family_name")
        .flex.column.flex-1.gap-10
          .col-title 名字* ( First Name)
          el-input(disabled, v-model="profile.given_name")
      .warn.flex.column
        .line 若需要變更姓名，請聯絡蛹之生人員
        .line If you need to change your name, please contact customer service.
      .row.flex.column.gap-10.rwd-wrap
        .flex.column.flex-1.gap-10
          .col-title 出生指定性別* ( Assigned at birth gender )
          el-select(placeholder="請選擇性別", v-model="profile.sex")
            el-option(label="男性", value="male")
            el-option(label="女性", value="female")
            el-option(label="其他", value="other")
        .flex.column.flex-1.gap-10
          .col-title 稱謂 ( Salutation )
          el-input(v-model="profile.wanna_be_called")
      .row.flex.column.gap-10.rwd-wrap
        .flex.column.flex-1.gap-10
          .col-title 出生年月日* ( Birthday )
          .input.flex.align-center
            el-date-picker.flex-1(
              placeholder="請選擇日期"
              v-model="profile.birthday")
      .row.flex.column.gap-10.rwd-wrap
        .warn.flex.column
          .line 身分證字號與護照號碼請至少擇一填寫
          .line Please fill at least one field of ID or passport.
      .row.flex.column.gap-10.rwd-wrap
        .flex.column.flex-1.gap-10
          .col-title 身分證字號 ( ID number )
          el-input(v-model="profile.id_number" :disabled="!canEditID", :placeholder="idPlaceholder")
          .warn.flex.column(v-if="!canEditID")
            .line 若需要變更身分證字號，請聯絡蛹之生個管師
            .line If you need to change your ID, please contact customer service.
        .flex.column.flex-1.gap-10
          .col-title 護照號碼 ( Passport )
          el-input(v-model="profile.passport" :disabled="!canEditPassport", :placeholder="passportPlaceholder")
          .warn.flex.column(v-if="!canEditPassport")
            .line 若需要變更護照號碼，請聯絡蛹之生個管師
            .line If you need to change your passport, please contact customer service.
      .row.flex.column.gap-10
        .flex.column.gap-10.left
          .col-title 國碼* ( Code )
          el-select(v-model="phoneCountry"  filterable)
            el-option(
              v-for="country in countryList"
              :key="country.code"
              :value="country.dial_code"
              :label="`${country.code} ${country.dial_code}`"
            )
        .flex.column.flex-1.gap-10
          .col-title  聯絡電話* ( Phone number )
          el-input(v-model="phone")
      .row.flex.column.gap-10
        .flex.column.flex-1.gap-10
          .col-title Email 登入帳號*  ( Email address )
          el-input(disabled v-model="profile.email")
      .warn.flex.column
        .line 若需要變更Email，請聯絡蛹之生個管師
        .line If you need to change your Email, please contact customer service.
      .row.flex.column.gap-10
        .flex.column.flex-1.gap-10
          .col-title 所在國家* (Country)
          el-select(
            filterable
            v-model="profile.country"
            @change="profile.county = ''; profile.district = ''")
            el-option(
              v-for="country in countryList"
              :key="country.code"
              :value="country.code"
              :label="`${country.flag} ${country.name}`"
            )
      .row.flex.column.gap-10.rwd-wrap(v-if="!profile.country || profile.country === 'TW'")
        .flex.column.flex-1.gap-10
          .col-title 縣市* ( City )
          el-select.input(
            autocomplete="off"
            filterable
            v-model="profile.county" placeholder="請輸入縣市")
            el-option(
              v-for="county in counties"
              :key="county"
              :label="county"
              :value="county")
        .flex.column.flex-1.gap-10
          .col-title 鄉鎮區* ( Township/ District )
          el-select.input(
            filterable
            :disabled="profile.county === undefined || profile.county === ''"
            v-model="profile.district" placeholder="請輸入鄉鎮")
            el-option(
              v-for="d in districts"
              :key="d"
              :label="d"
              :value="d")
      .row.flex.column.gap-10.rwd-wrap
        .flex.column.flex-1.gap-10
          .col-title 地址* ( Address )
          el-input(v-model="profile.address")
      .row.flex.column.gap-10.rwd-wrap
        .flex.column.flex-1.gap-10
          .col-title 感情狀態 ( Marital status )
          relation-select.input(v-model="profile.relationship")
        .flex.column.flex-1.gap-10
          .col-title 最高學歷 ( Education )
          education-select.input(v-model="profile.education")
        .flex.column.flex-1.gap-10
          .col-title 職業 ( Occupation )
          el-input(v-model="profile.job", placeholder="請輸入職業")
      .row.flex.column.gap-10
        .flex.column.flex-1.gap-10
          .col-title 緊急聯絡人*  ( Emergency contact )
          .flex.align-center.gap-10
            el-input(v-model="profile.emergency_person", placeholder="請輸入緊急聯絡人")
            el-input.right(v-model="profile.emergency_relationship", placeholder="請輸入關係")
      .row.flex.column.gap-10
        .flex.column.gap-10.left
          .col-title 國碼* ( Code )
          el-select(v-model="contactPhoneCountry" filterable)
            el-option(
              v-for="country in countryList"
              :key="country.code"
              :value="country.dial_code"
              :label="`${country.code} ${country.dial_code}`"
            )
        .flex.column.flex-1.gap-10
          .col-title  緊急聯絡人聯絡電話* ( Phone number of emergency contact )
          el-input(v-model="contactPhone")
      .row.flex.column.gap-10.rwd-wrap
        el-button.flex-1(@click="cancel") 取消
        el-button.app-primary.flex-1(type="primary", @click="save") 更新
</template>

<script>
import { mapMutations } from 'vuex';
import { getList } from 'country-list-with-dial-code-and-flag';
import {
  getCounties,
  getDistricts,
} from '@/util/address';
import {
  validateID,
} from '@/util/validator';
import { getProfileWithKey } from '@/api/auth';
import { submitForm } from '@/api/user';

export default {
  data() {
    const countries = getList();
    countries.sort((a, b) => (a.name > b.name ? 1 : -1));
    const idx = countries.findIndex((c) => c.dial_code === '+886');
    const tw = countries[idx];
    tw.name = 'Taiwan';
    countries.splice(idx, 1);
    countries.unshift(tw);
    const counties = getCounties();

    return {
      profile: {
        id_number: '',
        passport: '',
      },
      counties,
      countryList: countries,

      phone: '',
      phoneCountry: '',
      contactPhone: '',
      contactPhoneCountry: '',
      key: '',
      expired: false,
      canEditID: false,
      canEditPassport: false,

      idPlaceholder: '請輸入身分證字號',
      passportPlaceholder: '請輸入護照號碼',
    };
  },
  watch: {
    profile: {
      handler() {
        if (this.profile.id_number) {
          this.passportPlaceholder = '請輸入護照號碼 (選填)';
        } else {
          this.passportPlaceholder = '請輸入護照號碼';
        }
        if (this.profile.passport) {
          this.idPlaceholder = '請輸入身分證字號 (選填)';
        } else {
          this.idPlaceholder = '請輸入身分證字號';
        }
      },
      deep: true,
    },
  },
  computed: {
    districts() {
      return this.getDistricts(this.profile.county);
    },
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    getDistricts,
    isFormExpired(e) {
      // 表單連結自建立起 7 天內有效，逾期後端回 410 form_expired
      return e?.response?.status === 410 && e?.response?.data?.error === 'form_expired';
    },
    checkInput(data) {
      const errs = this.$initInputError();
      if (!data.gender) {
        errs.add('出生指定性別', '請選擇出生指定性別');
      }
      if (!data.birthday) {
        errs.add('生日', '請輸入生日');
      }
      // 後端回傳的未填欄位可能是 null，不能只比對空字串
      if (!data.emergency_contact
      || !data.emergency_relationship
      || !data.emergency_person) {
        errs.add('緊急聯絡人', '緊急聯絡人的關係與電話必須都填寫');
      }
      if (!data.id_number && !data.passport) {
        errs.add('身分證與護照號碼', '身分證與護照號碼至少需填寫一項');
      }
      if (data.id_number && !validateID(data.id_number)) {
        errs.add('身分證字號', '身分證字號格式錯誤');
      }
      if (!data.phone) {
        errs.add('聯絡電話', '請輸入聯絡電話');
      }
      if (data.country === 'TW' && (!data.county || !data.district)) {
        errs.add('縣市與鄉鎮區', '請選擇縣市與鄉鎮區');
      }
      // 地址欄位標示必填，不論國家都需填寫
      if (!data.address) {
        errs.add('地址', '請輸入地址');
      }

      if (errs.hasError) {
        const msg = errs.warnMessage;
        this.$showWarn(msg.title, msg.message);
        return false;
      }

      return true;
    },
    async loadData(key) {
      if (!key) {
        this.$showError('表單連結無效，請確認連結是否完整');
        return;
      }
      this.$execWithLoading(async () => {
        const rsp = await getProfileWithKey(key);
        this.profile = {
          ...rsp,
          job: rsp.job_title,
        };
        [this.phoneCountry, this.phone] = this.$splitPhone(rsp.phone);
        [this.contactPhoneCountry, this.contactPhone] = this.$splitPhone(rsp.emergency_contact);
        if (!this.profile.id_number) {
          this.canEditID = true;
        }
        if (!this.profile.passport) {
          this.canEditPassport = true;
        }
      }, (e) => {
        if (this.isFormExpired(e)) {
          this.expired = true;
          return;
        }
        console.log(e);
        this.$showError('載入資料失敗');
        this.$router.push('/login');
      });
    },
    cancel() {
      // 表單由連結開啟、沒有上一頁可回，改為重新載入原始資料以清除尚未送出的修改
      this.loadData(this.key);
    },
    async save() {
      const data = this.generateProfile(this.profile);
      if (!this.checkInput(data)) {
        return;
      }
      this.$execWithLoading(async () => {
        await submitForm(this.key, data);
        this.$showSuccess('更新成功');
        this.$router.push('/login');
      }, (e) => {
        // 填寫途中連結剛好逾期：後端拒絕寫入，改顯示過期提示
        if (this.isFormExpired(e)) {
          this.expired = true;
          this.$showError('此連結已過期，請聯絡個管師重新發送');
          return;
        }
        this.$showAxiosException('更新失敗', e);
      });
    },
    generateProfile(profile) {
      // 縣市/鄉鎮區只在台灣才會顯示，其他國家一律清空避免存到殘留值
      const showTWAddress = !profile.country || profile.country === 'TW';
      return {
        gender: profile.sex,
        wanna_be_called: profile.wanna_be_called,
        // 未填生日時保持空值，交給 checkInput 擋下；new Date(null) 會變成 1970-01-01
        birthday: profile.birthday ? this.$timestampToDate(new Date(profile.birthday)).replace(/\//g, '-') : '',
        id_number: profile.id_number,
        passport: profile.passport,
        phone: this.$getPhone(this.phoneCountry, this.phone),
        country: profile.country,
        county: showTWAddress ? profile.county : '',
        district: showTWAddress ? profile.district : '',
        address: profile.address,
        relationship: profile.relationship,
        education: profile.education,
        job: profile.job,
        emergency_person: profile.emergency_person,
        emergency_relationship: profile.emergency_relationship,
        emergency_contact: this.$getPhone(this.contactPhoneCountry, this.contactPhone),
        line_chat_id: profile.line_chat_id,
      };
    },
  },
  mounted() {
    const queryString = window.location.hash.replace('#/form', '');
    const urlParams = new URLSearchParams(queryString);
    const key = urlParams.get('key');
    this.key = key;
    this.setUserInfo(undefined);
    this.loadData(key);
  },
};
</script>

<style lang="scss" scoped>
.content-container {
  .form {
    width: 100vw;
    max-width: 590px;
  }
}
.expired {
  width: 100vw;
  max-width: 590px;
  padding: 60px 20px;
  text-align: center;
  .expired-title {
    font-size: 18px;
    font-weight: 600;
    color: #E6A23C;
  }
  .expired-sub {
    font-size: 13px;
    color: #909399;
  }
}
.warn {
  color: #E6A23C;
  font-family: Arial;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 169.231% */
}
.row {
  .left {
    flex: 0 0 120px;
  }
  .right {
    flex: 0 0 200px;
  }
}
.app-primary {
  background: #5AB0ACF5;
  color: white;
  border: none;
  &:hover {
    background: #5AB0AC;
  }
  &:active {
    background: #5AB0ACF5;
  }
  &:focus {
    background: #5AB0AC;
  }
}
.profile-setting-page {
  padding: 40px;
}

@media only screen and (max-width: 720px) {
  .profile-setting-page {
    padding: 20px;
    padding-bottom: 80px;
    .form {
      max-width: 100vw;
      padding: 20px;
    }
    .rwd-wrap {
      .flex-1 {
        min-width: 300px;
      }
    }
    .el-button {
      margin-left: 0;
    }
  }
}
</style>
